import { useLocation } from "react-router-dom";
import { openWhatsApp, WhatsAppIcon } from "@/components/Cta";

export default function WhatsAppLauncher() {
  const { pathname } = useLocation();
  if (pathname === "/team-inbox" || pathname === "/admin/leads") return null;

  return (
    <>
      {/* Mobile spacer so the sticky bar never covers footer content */}
      <div className="h-24 md:hidden" aria-hidden="true" />

      {/* Desktop floating WhatsApp button */}
      <button
        onClick={() => openWhatsApp("floating-whatsapp", { text: "WhatsApp 直接咨询" })}
        className="group fixed bottom-6 right-6 z-40 hidden items-center gap-3 rounded-full bg-forest py-3 pl-5 pr-6 text-paper shadow-[0_14px_36px_rgba(12,59,42,0.35)] transition-[transform,background-color] duration-300 hover:-translate-y-0.5 hover:bg-ink md:inline-flex"
        data-testid="whatsapp-launcher-desktop"
        data-location="floating-whatsapp"
      >
        <span className="relative flex h-2.5 w-2.5">
          <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-lime opacity-60" />
          <span className="relative inline-flex h-2.5 w-2.5 rounded-full bg-lime" />
        </span>
        <WhatsAppIcon size={18} className="transition-transform duration-300 group-hover:-rotate-12" />
        <span className="flex flex-col items-start leading-tight">
          <span className="text-sm font-semibold">WhatsApp 直接咨询</span>
          <span className="text-[10px] font-normal text-paper/60">有问题？直接问我们</span>
        </span>
      </button>

      {/* Mobile sticky bottom bar */}
      <div
        className="fixed inset-x-0 bottom-0 z-40 border-t border-ink/10 bg-white/95 px-4 pb-[max(0.75rem,env(safe-area-inset-bottom))] pt-2 backdrop-blur md:hidden"
        data-testid="whatsapp-launcher-mobile-bar"
      >
        <p className="mb-1.5 text-center text-[11px] font-medium text-ink/55">现在直接问</p>
        <button
          onClick={() => openWhatsApp("mobile-sticky-bar", { text: "WhatsApp 咨询" })}
          className="flex w-full items-center justify-center gap-2 rounded-full bg-forest py-3 text-sm font-semibold text-paper shadow-[0_10px_24px_rgba(12,59,42,0.3)]"
          data-testid="whatsapp-launcher-mobile"
          data-location="mobile-sticky-bar"
        >
          <WhatsAppIcon size={16} />
          WhatsApp 咨询
        </button>
      </div>
    </>
  );
}
